import apiRequest from './apiRequest';
import type { MotionKeyPoseStatePayload } from './postSceneObjectMotionKeyPoseEdit';

export type SaveKeyPosesRequest = {
  keyPoses: MotionKeyPoseStatePayload;
};

export type SaveKeyPosesResponse = {
  keyPoses?: MotionKeyPoseStatePayload;
  revision?: string;
  version?: string;
  updatedAt?: string;
  metadata?: Record<string, unknown>;
};

export default async function putSceneObjectMotionKeyPoses(
  sceneID: string,
  referenceName: string,
  timelineIndex: number,
  request: SaveKeyPosesRequest,
  apiKey: string,
  signal?: AbortSignal,
) {
  return apiRequest<SaveKeyPosesResponse>(
    'external-mogen',
    `/scenes/${encodeURIComponent(sceneID)}/objects/${encodeURIComponent(referenceName)}/${timelineIndex}/keyPoses`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
      body: JSON.stringify(request),
    },
    signal,
  );
}
